import * as React from 'react';

// Components
import Form from '@shopee/form-with-hook';

// Utils
import { isFeatureEnabled } from '@shopee-user/business-customization-logic';

// Constants
import { FORM_CONFIG, FORM_CONFIG_PHONE_ONLY } from './config';
import { Feature } from '@shopee-user/feature-toggle';

// Types
import { FormProps } from '@shopee/form-with-hook';

type Props = Pick<FormProps, Exclude<keyof FormProps, 'fieldConfigs'>>;

function SignupByOTPForm({ children, ...otherProps }: Props) {
  const isAllowSignupByEmail = isFeatureEnabled(Feature.SignupByOtpAllowEmail);
  return (
    <Form
      {...otherProps}
      fieldConfigs={isAllowSignupByEmail ? FORM_CONFIG : FORM_CONFIG_PHONE_ONLY}
    >
      {children}
    </Form>
  );
}

export default SignupByOTPForm;
